module.exports = __webpack_public_path__ + "static/face-ce1e58e70e3cdf6c6659717382217787.jpg";